import React, { useEffect, useState } from "react";
import "./cards.css";
import Status from "../../Reservation/Status";
const Cards = ({ reservations }) => {
  const [coming, setComing] = useState([]);
  const day = new Date().toISOString().substr(0, 10);
  useEffect(() => {
    const actualTime = new Date().getTime();
    let dayReservations = reservations.filter((r) => r.arriveData === day);
    dayReservations = dayReservations.filter((r) => r.isDone === false);
    for (let i = 0; i < dayReservations.length; i++) {
      dayReservations[i].miliseconds = new Date(
        `${dayReservations[i].arriveData}T${dayReservations[i].arriveHour}`
      ).getTime();
    }
    dayReservations = dayReservations.filter((r) => r.miliseconds > actualTime);
    const sortedReservations = dayReservations.sort(
      (a, b) => a.miliseconds - b.miliseconds
    );
    if (sortedReservations.length < 3) {
      switch (sortedReservations.length) {
        case 2:
          sortedReservations.push({ _id: Math.random() * 1000 });
          break;
        case 1:
          sortedReservations.push(
            { _id: Math.random() * 1000 },
            { _id: Math.random() * 1000 }
          );
          break;
        case 0:
          sortedReservations.push(
            { _id: Math.random() * 1000 },
            { _id: Math.random() * 1000 },
            { _id: Math.random() * 1000 }
          );
          break;
        default:
          console.log("something wrong");
      }
    }
    console.log(sortedReservations.length);
    setComing(sortedReservations.splice(0, 4));
  }, [day, reservations]);

  const cardList = coming.map((card) => (
    <div className="card" key={card._id}>
      <div className="CardContent">
        <h2>{card.arriveHour ? card.arriveHour : "Brak"}</h2>
        <div className="personalData">
          <span className="personalDataname">
            {card?.username ? card.username : "-----"}
          </span>
          <span className="personalDatasurname">
            {card?.surname ? card.surname : "-----"}
          </span>
          <p className="personalDataCarId">
            {card?.carId ? card.carId : "-----"}
          </p>
        </div>
        <hr className="hrCard" />
        <div className="time">
          <span className="h3Time">DATA PRZYJAZDU:</span>
          <br />
          <span className="spanTime">
            {card?.arriveData ? card.arriveData : "-----"}
          </span>
          <span className="spanHour">
            {card?.arriveHour ? card.arriveHour : "-----"}
          </span>
        </div>
        <div className="status">
          <Status reservation={card} card={true} />
        </div>
      </div>
    </div>
  ));

  return (
    <>
      <div className="container">{cardList}</div>
    </>
  );
};

export default Cards;
